var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      staticClass: "icp-nudge__modal",
      attrs: {
        "close-button-color": "black",
        "enable-translucid-close-button": false,
        "show-close-button": true
      },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "div",
        { staticClass: "icp-nudge__content" },
        [
          _c("div", { staticClass: "icp-nudge__asset" }, [
            _c("img", {
              attrs: {
                src:
                  "/site_media/version-972a97145e/images/course-page/gold-stars.gif",
                alt: "Gold stars"
              }
            })
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "icp-nudge__header" }, [
            _vm._v("\n      You discovered a "),
            _c("span", { staticClass: "highlight" }, [
              _vm._v("Premium lesson!")
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "icp-nudge__body" }, [
            _vm._v(
              "\n      Upgrade to unlock all lessons in " +
                _vm._s(_vm.courseName) +
                ", and all 70+ courses and learning paths.\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "Button",
            {
              directives: [
                {
                  name: "track",
                  rawName: "v-track:click",
                  value: { axId: "clicked_icp_locked_modal_nudge_cta" },
                  expression: "{ axId: 'clicked_icp_locked_modal_nudge_cta' }",
                  arg: "click"
                }
              ],
              staticClass: "icp-nudge__continue-button",
              attrs: { to: "/premium", green: "", primary: "" }
            },
            [_vm._v("\n      Learn more\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }